<template>
    <div class="role-switcher relative">
        <Button v-if="authStore.hasMultipleRoles" :label="authStore.activeRoleLabel" icon="pi pi-user"
            severity="secondary" outlined @click="toggleMenu" class="font-semibold"
            :badge="String(authStore.availableRoles.length)" />

        <Button v-else :label="authStore.activeRoleLabel" icon="pi pi-user" severity="secondary" outlined
            class="font-semibold" disabled />

        <Menu v-if="authStore.hasMultipleRoles" ref="menu" :model="roleMenuItems" popup class="w-20rem max-w-full">
            <template #start>
                <div class="flex align-items-center gap-2 px-4 py-3 border-bottom-1 surface-border font-semibold text-color">
                    <i class="pi pi-users text-primary"></i>
                    <span>Alternar Perfil</span>
                </div>
            </template>
        </Menu>

        <RoleChangeOverlay :visible="isChangingRole" :old-role-icon="oldRoleIcon" :new-role-icon="newRoleIcon"
            :message="roleChangeMessage" />
    </div>
</template>

<script setup lang="ts">
import RoleChangeOverlay from "@/components/RoleChangeOverlay.vue";
import { useRoleSwitching } from "@/composables/useRoleSwitching";
import { useAuthStore } from "@/stores/AuthStore";
import Button from "primevue/button";
import Menu from "primevue/menu";
import { computed, ref } from "vue";

const authStore = useAuthStore();
const menu = ref();
const {
    buildRoleMenuItems,
    isChangingRole,
    newRoleIcon,
    oldRoleIcon,
    roleChangeMessage,
} = useRoleSwitching();

const roleMenuItems = computed(() => buildRoleMenuItems({
    activeClass: "font-semibold surface-100 border-left-3 border-primary",
    onBeforeSwitch: () => menu.value?.hide?.(),
}));

function toggleMenu(event: Event): void {
    menu.value?.toggle(event);
}
</script>
